var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("navbar"),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c("div", { staticClass: "container" }, [
            _c(
              "div",
              { staticClass: "col-md-12 p-0" },
              [
                _c("router-link", { attrs: { to: "top" } }, [
                  _vm._v(_vm._s(_vm.$t("ordertop.myhome")))
                ]),
                _vm._v(" / "),
                _c("router-link", { attrs: { to: "info" } }, [
                  _vm._v(_vm._s(_vm.$t("Settingspage.SettingsTop")))
                ]),
                _vm._v(
                  " / " +
                    _vm._s(_vm.$t("UpdateInfoTop.UpdateInfo")) +
                    "\n          "
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-4 row justify-content-start col-12 col-sm-9 col-md-7 col-lg-5"
                  },
                  [
                    _c("ul", { staticClass: "nav nav-tabs wizard pr-0 pl-0" }, [
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 1,
                            completed: _vm.step > 1
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.$t("UpdateInfoTop.Input")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 2,
                            completed: _vm.step > 2
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.$t("UpdateInfoTop.Confirm")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.step === 3,
                            completed: _vm.step > 3
                          }
                        },
                        [
                          _c("a", [
                            _vm._v(_vm._s(_vm.$t("UpdateInfoTop.Complete")))
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.step === 1 || _vm.step == 2
                  ? _c("div", [
                      _c("div", { staticClass: "card mt-4" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", {}, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("UpdateInfoTop.text")))
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card mt-4 pt-3 pb-3" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "form",
                            {
                              staticClass:
                                "demo-ruleForm pt-4 needs-validation",
                              attrs: { "label-width": "0px", novalidate: "" }
                            },
                            [
                              _c(
                                "h5",
                                { staticClass: "card-title pt-3 pl-3 " },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("UpdateInfoForm.UserInforTitle")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "name" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("UpdateInfoForm.MyName"))
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-8" }, [
                                  _c("div", { staticClass: "col-12 p-0" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userInfo.user_name,
                                          expression: "userInfo.user_name"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        id: "name",
                                        maxlength: "128",
                                        "aria-label": "username",
                                        "aria-describedby": "basic-addon2",
                                        readonly: _vm.step === 2,
                                        required: ""
                                      },
                                      domProps: {
                                        value: _vm.userInfo.user_name
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.userInfo,
                                            "user_name",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "UpdateInfoForm.MyNameTips"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "telephone" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.MyTelephone")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-8" }, [
                                  _c("div", { staticClass: "col-12 p-0" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.userInfo.user_telephone,
                                          expression: "userInfo.user_telephone"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "tel",
                                        maxlength: "128",
                                        id: "telephone",
                                        "aria-describedby": "basic-addon2",
                                        readonly: _vm.step === 2,
                                        required: ""
                                      },
                                      domProps: {
                                        value: _vm.userInfo.user_telephone
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.userInfo,
                                            "user_telephone",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n                          " +
                                            _vm._s(
                                              _vm.$t(
                                                "UpdateInfoForm.TelephoneTips1"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "language" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.language")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.userInfo.language_code,
                                                expression:
                                                  "userInfo.language_code"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "language",
                                              "aria-describedby":
                                                "basic-addon2",
                                              disabled: _vm.step === 2
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$selectedVal = Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function(o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function(o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                                _vm.$set(
                                                  _vm.userInfo,
                                                  "language_code",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "en" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "languageChoice.English"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "jp" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "languageChoice.Japanese"
                                                    )
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "zh" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "languageChoice.Chinese"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "h5",
                                { staticClass: "card-title pt-3 pl-3 " },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("UpdateInfoForm.FairFX"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "nav",
                                { staticClass: "navbar navbar-light col-12" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col-12 col-md-4" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "navbar-brand",
                                          attrs: { for: "fairFX" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "UpdateInfoForm.FairFXNumber"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form-inline col-12 col-md-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "input-group col-12 p-0"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.userInfo.fairfx_number,
                                                expression:
                                                  "userInfo.fairfx_number"
                                              }
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              id: "fairFX",
                                              maxlength: "128",
                                              type: "text",
                                              readonly: _vm.step === 2
                                            },
                                            domProps: {
                                              value: _vm.userInfo.fairfx_number
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.userInfo,
                                                  "fairfx_number",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h5",
                                { staticClass: "card-title pt-3 pl-3 " },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("UpdateInfoForm.BankAccount"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "accountHolderName" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "UpdateInfoForm.accountHolderName"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.account_name,
                                              expression:
                                                "userInfo.account_name"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "accountHolderName",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "firstName" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.firstName")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.first_name,
                                              expression: "userInfo.first_name"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "firstName",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.first_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "first_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "lastName" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.lastName")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.last_name,
                                              expression: "userInfo.last_name"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "lastName",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.last_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "last_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "street" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.myResidence")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.userInfo.account_street,
                                              expression:
                                                "userInfo.account_street"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "street",
                                            maxlength: "128",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_street
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_street",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "city" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("UpdateInfoForm.mycity"))
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.account_city,
                                              expression:
                                                "userInfo.account_city"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "city",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_city
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_city",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "postcode" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.myPostalCode")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.userInfo.account_postcode,
                                              expression:
                                                "userInfo.account_postcode"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "postcode",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_postcode
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_postcode",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "country" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.mycountry")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.userInfo.account_country,
                                              expression:
                                                "userInfo.account_country"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            id: "country",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_country
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_country",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "accountNumber" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.accountNumber")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.userInfo.account_number,
                                              expression:
                                                "userInfo.account_number"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "accountNumber",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_number
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_number",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "bankName" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.bankName")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.bank_name,
                                              expression: "userInfo.bank_name"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "bankName",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.bank_name
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_name",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "bankStreet" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.bankStreet")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.bank_street,
                                              expression: "userInfo.bank_street"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "bankStreet",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.bank_street
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_street",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "bankCountry" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.bankCountry")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.bank_country,
                                              expression:
                                                "userInfo.bank_country"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            id: "bankCountry",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.bank_country
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_country",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "bankSWIFT" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("UpdateInfoForm.bankSWIFT")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group p-0 col-12" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.bank_swift,
                                              expression: "userInfo.bank_swift"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            "border-bottom-right-radius":
                                              "0.35rem",
                                            "border-top-right-radius": "0.35rem"
                                          },
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "bankSWIFT",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.bank_swift
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_swift",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "navbar-brand ml-3",
                                            attrs: { for: "routing" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("UpdateInfoForm.routing")
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.bank_routing,
                                              expression:
                                                "userInfo.bank_routing"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          staticStyle: {
                                            "border-bottom-left-radius":
                                              "0.35rem",
                                            "border-top-left-radius": "0.35rem"
                                          },
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "routing",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.bank_routing
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_routing",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "IBAN" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("UpdateInfoForm.IBAN"))
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.account_iban,
                                              expression:
                                                "userInfo.account_iban"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            maxlength: "128",
                                            id: "IBAN",
                                            "aria-describedby": "basic-addon2",
                                            readonly: _vm.step === 2
                                          },
                                          domProps: {
                                            value: _vm.userInfo.account_iban
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "account_iban",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("nav", { staticClass: "navbar col-12" }, [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "BACS" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("UpdateInfoForm.BACS"))
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox p-0 pl-4"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.userInfo.bank_bacs_sepa,
                                              expression:
                                                "userInfo.bank_bacs_sepa"
                                            }
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "BACS",
                                            type: "checkbox",
                                            "aria-label":
                                              "Checkbox for following text input",
                                            disabled: _vm.step === 2
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.userInfo.bank_bacs_sepa
                                            )
                                              ? _vm._i(
                                                  _vm.userInfo.bank_bacs_sepa,
                                                  null
                                                ) > -1
                                              : _vm.userInfo.bank_bacs_sepa
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a =
                                                  _vm.userInfo.bank_bacs_sepa,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.userInfo,
                                                      "bank_bacs_sepa",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.userInfo,
                                                      "bank_bacs_sepa",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.userInfo,
                                                  "bank_bacs_sepa",
                                                  $$c
                                                )
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: "BACS" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step === 3
                  ? _c("div", [
                      _c("div", { staticClass: "card p-0 mt-4 pt-3 pb-3" }, [
                        _c(
                          "div",
                          { staticClass: "p-5 text-center" },
                          [
                            _c("p", { staticClass: "lead" }, [
                              _vm._v(_vm._s(_vm.$t("UpdateComplete.Complete")))
                            ]),
                            _vm._v(" "),
                            _c("hr", { staticClass: "my-4 display-4" }),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-lg btn-primary",
                                attrs: { to: "/user/info" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("UpdateComplete.ReturnSettings")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4 col-12 p-0 no-gutters" }, [
              _vm.step < 3
                ? _c("div", { staticClass: "col-6" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        on: { click: _vm.clickBack }
                      },
                      [_vm._v(_vm._s(_vm.$t("UpdateInfoForm.Backbtn")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 1
                ? _c("div", { staticClass: "col-6 text-right p-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.validator }
                      },
                      [_vm._v(_vm._s(_vm.$t("UpdateInfoForm.Confirmbtn")))]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2
                ? _c("div", { staticClass: "col-6 text-right p-0" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: { click: _vm.changeInfo }
                      },
                      [_vm._v(_vm._s(_vm.$t("UpdateInfoForm.Changebtn")))]
                    )
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright"),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "demo-ruleForm needs-validation",
          attrs: { "label-width": "0px", novalidate: "" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: {
                id: "authenticatorModal",
                tabindex: "-1",
                role: "dialog",
                "aria-labelledby": "authenticatorModalLabel",
                "aria-hidden": "true"
              }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "h4",
                      {
                        staticClass: "modal-title",
                        attrs: { id: "authenticatorModalLabel" }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t("TwiceVerification.twiceVerification")
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body pt-5 pb-5" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "TwiceVerification.verificationCodeExplainInfo"
                            )
                          )
                        )
                      ]),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "verificationCodeStep2" } }, [
                        _c("h5", [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.verificationCode"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.verificationCode,
                            expression: "verificationCode"
                          }
                        ],
                        staticClass: "form-control form-control-lg mt-2",
                        attrs: { id: "verificationCodeStep2", required: "" },
                        domProps: { value: _vm.verificationCode },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.verificationCode = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t(
                                "TwiceVerification.verificationCodeRequired"
                              )
                            ) +
                            "\n              "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer pt-5 pb-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-outline-secondary",
                          attrs: { type: "button", "data-dismiss": "modal" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("modal.modalCancel")) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-6 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-lg btn-primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.userInfoUpdate }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("TwiceVerification.modalSubmit"))
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-990d3bde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-990d3bde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/update-info.vue
// module id = null
// module chunks = 